import React, { useState, Component } from 'react';
import { ShoppingCart, Search, Phone, MapPin, Menu, X, Clock } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../../hooks/useCart';
import { LanguageToggle } from '../ui/LanguageToggle';
export function TopNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    totalItems
  } = useCart();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileSearchQuery, setMobileSearchQuery] = useState('');
  const navItems = [{
    path: '/',
    label: 'Home'
  }, {
    path: '/search',
    label: 'Shop'
  }, {
    path: '/wic-ebt-guide',
    label: 'WIC/EBT Guide'
  }];
  const handleMobileSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (mobileSearchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(mobileSearchQuery)}`);
      setMobileSearchQuery('');
    }
  };
  return <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4" data-id="element-56">
        <div className="md:hidden" data-id="element-57">
          <div className="flex items-center justify-between mb-3" data-id="element-58">
            <div className="flex items-center gap-2" data-id="element-59">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 -ml-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Menu" data-id="element-60">
                <Menu className="w-6 h-6 text-gray-700" data-id="element-61" />
              </button>
              <Link to="/" className="flex items-center gap-2" data-id="element-62">
                <div className="w-9 h-9 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center shadow-md" data-id="element-63">
                  <span className="text-lg font-bold text-white" data-id="element-64">D</span>
                </div>
                <div className="flex flex-col" data-id="element-65">
                  <span className="text-sm font-bold text-gray-900 leading-tight" data-id="element-66">
                    D-grace Intl
                  </span>
                  <span className="text-[10px] text-gray-500 font-medium" data-id="element-67">
                    Food Store
                  </span>
                </div>
              </Link>
            </div>
            <div className="flex items-center gap-1" data-id="element-68">
              <a href="tel:2404709453" className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Call us" data-id="element-69">
                <Phone className="w-5 h-5 text-gray-700" data-id="element-70" />
              </a>
              <Link to="/cart" className="relative p-2 -mr-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Shopping cart" data-id="element-71">
                <ShoppingCart className="w-6 h-6 text-gray-700" data-id="element-72" />
                {totalItems > 0 && <motion.span initial={{
                scale: 0
              }} animate={{
                scale: 1
              }} className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs font-bold h-5 w-5 flex items-center justify-center rounded-full border-2 border-white" data-id="element-73">
                    {totalItems}
                  </motion.span>}
              </Link>
            </div>
          </div>
          <form onSubmit={handleMobileSearch} className="relative" data-id="element-74">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" data-id="element-75" />
            <input type="text" placeholder="Search for yams, spices..." value={mobileSearchQuery} onChange={e => setMobileSearchQuery(e.target.value)} className="w-full bg-gray-50 border border-gray-200 rounded-lg py-2.5 pl-10 pr-4 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent focus:bg-white transition-all" data-id="element-76" />
          </form>
        </div>

        <div className="hidden md:flex items-center justify-between" data-id="element-77">
          <Link to="/" className="flex items-center gap-3" data-id="element-78">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center shadow-md" data-id="element-79">
              <span className="text-2xl font-bold text-white" data-id="element-80">D</span>
            </div>
            <div className="flex flex-col" data-id="element-81">
              <span className="text-xl font-bold text-gray-900 leading-tight" data-id="element-82">
                D-grace International
              </span>
              <span className="text-xs text-gray-500 font-medium" data-id="element-83">
                Food Store
              </span>
            </div>
          </Link>

          <div className="flex items-center gap-8" data-id="element-84">
            {navItems.map(item => {
            const isActive = location.pathname === item.path;
            return <Link key={item.path} to={item.path} className="relative py-2 px-1" data-id="element-85">
                  <span className={`text-sm font-semibold transition-colors ${isActive ? 'text-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-86">
                    {item.label}
                  </span>
                  {isActive && <motion.div layoutId="nav-underline" className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" transition={{
                type: 'spring',
                bounce: 0.2,
                duration: 0.6
              }} data-id="element-87" />}
                </Link>;
          })}
          </div>

          <div className="flex items-center gap-4" data-id="element-88">
            <div className="hidden lg:flex items-center gap-4 text-sm text-gray-600" data-id="element-89">
              <div className="flex items-center gap-1.5" data-id="element-90">
                <Phone className="w-4 h-4" data-id="element-91" />
                <span className="font-medium" data-id="element-92">(240) 470-9453</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-93">
                <MapPin className="w-4 h-4" data-id="element-94" />
                <span className="font-medium" data-id="element-95">Hyattsville, MD</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-96">
                <Clock className="w-4 h-4" data-id="element-97" />
                <span className="font-medium" data-id="element-98">Mon-Sat: 9am-9pm</span>
              </div>
            </div>
            <LanguageToggle data-id="element-99" />
            <Link to="/search" className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Search" data-id="element-100">
              <Search className="w-5 h-5 text-gray-600" data-id="element-101" />
            </Link>
            <Link to="/cart" className="relative p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Shopping cart" data-id="element-102">
              <ShoppingCart className="w-5 h-5 text-gray-600" data-id="element-103" />
              {totalItems > 0 && <motion.span initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs font-bold h-5 w-5 flex items-center justify-center rounded-full border-2 border-white" data-id="element-104">
                  {totalItems}
                </motion.span>}
            </Link>
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-105">
        {isMobileMenuOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsMobileMenuOpen(false)} className="fixed inset-0 bg-black/50 z-40 md:hidden" data-id="element-106" />
            <motion.div initial={{
          x: '-100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '-100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed left-0 top-0 bottom-0 w-80 bg-white shadow-2xl z-50 md:hidden overflow-y-auto" data-id="element-107">
              <div className="p-6" data-id="element-108">
                <div className="flex items-center justify-between mb-8" data-id="element-109">
                  <div className="flex items-center gap-3" data-id="element-110">
                    <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center shadow-md" data-id="element-111">
                      <span className="text-xl font-bold text-white" data-id="element-112">D</span>
                    </div>
                    <div className="flex flex-col" data-id="element-113">
                      <span className="text-base font-bold text-gray-900 leading-tight" data-id="element-114">
                        D-grace International
                      </span>
                      <span className="text-xs text-gray-500 font-medium" data-id="element-115">
                        Food Store
                      </span>
                    </div>
                  </div>
                  <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Close menu" data-id="element-116">
                    <X className="w-6 h-6 text-gray-700" data-id="element-117" />
                  </button>
                </div>
                <nav className="space-y-2 mb-8" data-id="element-118">
                  {navItems.map(item => {
                const isActive = location.pathname === item.path;
                return <Link key={item.path} to={item.path} onClick={() => setIsMobileMenuOpen(false)} className={`block px-4 py-3 rounded-xl font-semibold transition-colors ${isActive ? 'bg-blue-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-119">
                        {item.label}
                      </Link>;
              })}
                </nav>
                <div className="mb-8" data-id="element-120">
                  <LanguageToggle data-id="element-121" />
                </div>
                <div className="space-y-3 pt-6 border-t border-gray-200" data-id="element-122">
                  <a href="tel:2404709453" className="flex items-center gap-3 text-sm text-gray-600 hover:text-blue-600 transition-colors" data-id="element-123">
                    <Phone className="w-4 h-4" data-id="element-124" />
                    <span className="font-medium" data-id="element-125">(240) 470-9453</span>
                  </a>
                  <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-126">
                    <MapPin className="w-4 h-4" data-id="element-127" />
                    <span className="font-medium" data-id="element-128">
                      7513 Landover Rd, Hyattsville, MD 20785
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-129">
                    <Clock className="w-4 h-4" data-id="element-130" />
                    <span className="font-medium" data-id="element-131">Mon-Sat: 9am-9pm</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </nav>;
}